import type { RouteMatch, RouteObject } from 'react-router';
import { matchRoutes } from 'react-router';

function trimSlash(path: string): string {
  return path.replace(/\/\*?$/, '');
}

function prefixWithSlash(path: string): string {
  return path[0] === '/' ? path : `/${path}`;
}

function getNormalizedName(branches: RouteMatch[]) {
  let pathBuilder = '';
  if (branches) {
    for (const branch of branches) {
      const { route } = branch;
      if (route?.path) {
        const { path } = route;
        pathBuilder = trimSlash(pathBuilder) + prefixWithSlash(path);
      }
    }
  }
  return pathBuilder;
}

export const getPathPattern = (
  routeObjects: RouteObject[],
  pathname: string,
  basename?: string
) => {
  const routes = matchRoutes(routeObjects, pathname, basename);
  return getNormalizedName(routes ?? []);
};
